// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as AdMappingRouteImport } from './routes/ad-mapping'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as HandoffRouteImport } from './routes/handoff'
import { Route as LayoutPortfolioRouteImport } from './routes/_layout.portfolio'
import { Route as LoginGuestRouteImport } from './routes/login/_guest'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as UsersSplatRouteImport } from './routes/users.$'
import { Route as LayoutAdminSettingsIndexRouteImport } from './routes/_layout.admin-settings.index'
import { Route as LayoutAdminIndexRouteImport } from './routes/_layout.admin.index'
import { Route as LayoutAdminPartnerIdRouteImport } from './routes/_layout.admin.$partnerId'
import { Route as LayoutAionIndexRouteImport } from './routes/_layout.aion.index'
import { Route as LayoutAionApplicationIdRouteImport } from './routes/_layout.aion.$applicationId'
import { Route as LayoutApplicationsTwoFlowApplicationIdRouteImport } from './routes/_layout.applications-two-flow.$applicationId'
import { Route as LayoutApplicationsIndexRouteImport } from './routes/_layout.applications.index'
import { Route as LayoutApplicationsApplicationIdRouteImport } from './routes/_layout.applications.$applicationId'
import { Route as LayoutDashboardIndexRouteImport } from './routes/_layout.dashboard.index'
import { Route as LayoutMonitoringIndexRouteImport } from './routes/_layout.monitoring.index'
import { Route as LayoutPortfolioIndexRouteImport } from './routes/_layout.portfolio.index'
import { Route as LayoutPortfolioBucketMovementRouteImport } from './routes/_layout.portfolio.bucket-movement'
import { Route as LayoutPortfolioCreditLossRouteImport } from './routes/_layout.portfolio.credit-loss'
import { Route as LayoutPortfolioEarlyWarningRouteImport } from './routes/_layout.portfolio.early-warning'
import { Route as LayoutPortfolioOverviewRouteImport } from './routes/_layout.portfolio.overview'
import { Route as LayoutPortfolioVintageRouteImport } from './routes/_layout.portfolio.vintage'
import { Route as LayoutSettingsIndexRouteImport } from './routes/_layout.settings.index'
import { Route as LayoutStressTestIndexRouteImport } from './routes/_layout.stress-test.index'
import { Route as LayoutStressTestScenarioIdRouteImport } from './routes/_layout.stress-test.$scenarioId'
import { Route as LayoutStressTestConfigRouteImport } from './routes/_layout.stress-test.config'
import { Route as LayoutStressTestResultsRouteImport } from './routes/_layout.stress-test.results'
import { Route as LoginGuestIndexRouteImport } from './routes/login/_guest.index'
import { Route as LoginGuestTempRouteImport } from './routes/login/_guest.temp'
import { Route as LayoutApplicationsGroupGroupScoringIdRouteImport } from './routes/_layout.applications.group.$groupScoringId'
import { Route as LayoutMonitoringModelIdIndexRouteImport } from './routes/_layout.monitoring.$modelId.index'
import { Route as LayoutMonitoringModelIdConfigRouteImport } from './routes/_layout.monitoring.$modelId.config'
import { Route as LayoutStressTestDocsMetricRouteImport } from './routes/_layout.stress-test.docs.$metric'
import { Route as LayoutSettingsModelsModelIdIndexRouteImport } from './routes/_layout.settings.models.$modelId.index'
import { Route as LayoutSettingsOcrOcrIdIndexRouteImport } from './routes/_layout.settings.ocr.$ocrId.index'
import { Route as LayoutSettingsOcrOcrIdGroupRouteImport } from './routes/_layout.settings.ocr.$ocrId.group'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const AdMappingRoute = AdMappingRouteImport.update({
            id: '/ad-mapping',path: '/ad-mapping',getParentRoute: () => rootRouteImport
          })
const AuditRoute = AuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => rootRouteImport
          })
const HandoffRoute = HandoffRouteImport.update({
            id: '/handoff',path: '/handoff',getParentRoute: () => rootRouteImport
          })
const LayoutPortfolioRoute = LayoutPortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => LayoutRoute
          })
const LoginGuestRoute = LoginGuestRouteImport.update({
            id: '/login/_guest',path: '/login',getParentRoute: () => rootRouteImport
          })
const UsersIndexRoute = UsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => rootRouteImport
          })
const UsersSplatRoute = UsersSplatRouteImport.update({
            id: '/users/$',path: '/users/$',getParentRoute: () => rootRouteImport
          })
const LayoutAdminSettingsIndexRoute = LayoutAdminSettingsIndexRouteImport.update({
            id: '/admin-settings/',path: '/admin-settings/',getParentRoute: () => LayoutRoute
          })
const LayoutAdminIndexRoute = LayoutAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => LayoutRoute
          })
const LayoutAdminPartnerIdRoute = LayoutAdminPartnerIdRouteImport.update({
            id: '/admin/$partnerId',path: '/admin/$partnerId',getParentRoute: () => LayoutRoute
          })
const LayoutAionIndexRoute = LayoutAionIndexRouteImport.update({
            id: '/aion/',path: '/aion/',getParentRoute: () => LayoutRoute
          })
const LayoutAionApplicationIdRoute = LayoutAionApplicationIdRouteImport.update({
            id: '/aion/$applicationId',path: '/aion/$applicationId',getParentRoute: () => LayoutRoute
          })
const LayoutApplicationsTwoFlowApplicationIdRoute = LayoutApplicationsTwoFlowApplicationIdRouteImport.update({
            id: '/applications-two-flow/$applicationId',path: '/applications-two-flow/$applicationId',getParentRoute: () => LayoutRoute
          })
const LayoutApplicationsIndexRoute = LayoutApplicationsIndexRouteImport.update({
            id: '/applications/',path: '/applications/',getParentRoute: () => LayoutRoute
          })
const LayoutApplicationsApplicationIdRoute = LayoutApplicationsApplicationIdRouteImport.update({
            id: '/applications/$applicationId',path: '/applications/$applicationId',getParentRoute: () => LayoutRoute
          })
const LayoutDashboardIndexRoute = LayoutDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => LayoutRoute
          })
const LayoutMonitoringIndexRoute = LayoutMonitoringIndexRouteImport.update({
            id: '/monitoring/',path: '/monitoring/',getParentRoute: () => LayoutRoute
          })
const LayoutPortfolioIndexRoute = LayoutPortfolioIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutPortfolioRoute
          })
const LayoutPortfolioBucketMovementRoute = LayoutPortfolioBucketMovementRouteImport.update({
            id: '/bucket-movement',path: '/bucket-movement',getParentRoute: () => LayoutPortfolioRoute
          })
const LayoutPortfolioCreditLossRoute = LayoutPortfolioCreditLossRouteImport.update({
            id: '/credit-loss',path: '/credit-loss',getParentRoute: () => LayoutPortfolioRoute
          })
const LayoutPortfolioEarlyWarningRoute = LayoutPortfolioEarlyWarningRouteImport.update({
            id: '/early-warning',path: '/early-warning',getParentRoute: () => LayoutPortfolioRoute
          })
const LayoutPortfolioOverviewRoute = LayoutPortfolioOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => LayoutPortfolioRoute
          })
const LayoutPortfolioVintageRoute = LayoutPortfolioVintageRouteImport.update({
            id: '/vintage',path: '/vintage',getParentRoute: () => LayoutPortfolioRoute
          })
const LayoutSettingsIndexRoute = LayoutSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => LayoutRoute
          })
const LayoutStressTestIndexRoute = LayoutStressTestIndexRouteImport.update({
            id: '/stress-test/',path: '/stress-test/',getParentRoute: () => LayoutRoute
          })
const LayoutStressTestScenarioIdRoute = LayoutStressTestScenarioIdRouteImport.update({
            id: '/stress-test/$scenarioId',path: '/stress-test/$scenarioId',getParentRoute: () => LayoutRoute
          })
const LayoutStressTestConfigRoute = LayoutStressTestConfigRouteImport.update({
            id: '/stress-test/config',path: '/stress-test/config',getParentRoute: () => LayoutRoute
          })
const LayoutStressTestResultsRoute = LayoutStressTestResultsRouteImport.update({
            id: '/stress-test/results',path: '/stress-test/results',getParentRoute: () => LayoutRoute
          })
const LoginGuestIndexRoute = LoginGuestIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LoginGuestRoute
          })
const LoginGuestTempRoute = LoginGuestTempRouteImport.update({
            id: '/temp',path: '/temp',getParentRoute: () => LoginGuestRoute
          })
const LayoutApplicationsGroupGroupScoringIdRoute = LayoutApplicationsGroupGroupScoringIdRouteImport.update({
            id: '/applications/group/$groupScoringId',path: '/applications/group/$groupScoringId',getParentRoute: () => LayoutRoute
          })
const LayoutMonitoringModelIdIndexRoute = LayoutMonitoringModelIdIndexRouteImport.update({
            id: '/monitoring/$modelId/',path: '/monitoring/$modelId/',getParentRoute: () => LayoutRoute
          })
const LayoutMonitoringModelIdConfigRoute = LayoutMonitoringModelIdConfigRouteImport.update({
            id: '/monitoring/$modelId/config',path: '/monitoring/$modelId/config',getParentRoute: () => LayoutRoute
          })
const LayoutStressTestDocsMetricRoute = LayoutStressTestDocsMetricRouteImport.update({
            id: '/stress-test/docs/$metric',path: '/stress-test/docs/$metric',getParentRoute: () => LayoutRoute
          })
const LayoutSettingsModelsModelIdIndexRoute = LayoutSettingsModelsModelIdIndexRouteImport.update({
            id: '/settings/models/$modelId/',path: '/settings/models/$modelId/',getParentRoute: () => LayoutRoute
          })
const LayoutSettingsOcrOcrIdIndexRoute = LayoutSettingsOcrOcrIdIndexRouteImport.update({
            id: '/settings/ocr/$ocrId/',path: '/settings/ocr/$ocrId/',getParentRoute: () => LayoutRoute
          })
const LayoutSettingsOcrOcrIdGroupRoute = LayoutSettingsOcrOcrIdGroupRouteImport.update({
            id: '/settings/ocr/$ocrId/group',path: '/settings/ocr/$ocrId/group',getParentRoute: () => LayoutRoute
          })





const LayoutPortfolioRouteChildren = {
  LayoutPortfolioBucketMovementRoute: LayoutPortfolioBucketMovementRoute,LayoutPortfolioCreditLossRoute: LayoutPortfolioCreditLossRoute,LayoutPortfolioEarlyWarningRoute: LayoutPortfolioEarlyWarningRoute,LayoutPortfolioOverviewRoute: LayoutPortfolioOverviewRoute,LayoutPortfolioVintageRoute: LayoutPortfolioVintageRoute,LayoutPortfolioIndexRoute: LayoutPortfolioIndexRoute
}

const LayoutPortfolioRouteWithChildren = LayoutPortfolioRoute._addFileChildren(LayoutPortfolioRouteChildren)



const LayoutRouteChildren = {
  LayoutPortfolioRoute: LayoutPortfolioRouteWithChildren,LayoutAdminPartnerIdRoute: LayoutAdminPartnerIdRoute,LayoutAionApplicationIdRoute: LayoutAionApplicationIdRoute,LayoutApplicationsTwoFlowApplicationIdRoute: LayoutApplicationsTwoFlowApplicationIdRoute,LayoutApplicationsApplicationIdRoute: LayoutApplicationsApplicationIdRoute,LayoutStressTestScenarioIdRoute: LayoutStressTestScenarioIdRoute,LayoutStressTestConfigRoute: LayoutStressTestConfigRoute,LayoutStressTestResultsRoute: LayoutStressTestResultsRoute,LayoutAdminSettingsIndexRoute: LayoutAdminSettingsIndexRoute,LayoutAdminIndexRoute: LayoutAdminIndexRoute,LayoutAionIndexRoute: LayoutAionIndexRoute,LayoutApplicationsIndexRoute: LayoutApplicationsIndexRoute,LayoutDashboardIndexRoute: LayoutDashboardIndexRoute,LayoutMonitoringIndexRoute: LayoutMonitoringIndexRoute,LayoutSettingsIndexRoute: LayoutSettingsIndexRoute,LayoutStressTestIndexRoute: LayoutStressTestIndexRoute,LayoutApplicationsGroupGroupScoringIdRoute: LayoutApplicationsGroupGroupScoringIdRoute,LayoutMonitoringModelIdConfigRoute: LayoutMonitoringModelIdConfigRoute,LayoutStressTestDocsMetricRoute: LayoutStressTestDocsMetricRoute,LayoutMonitoringModelIdIndexRoute: LayoutMonitoringModelIdIndexRoute,LayoutSettingsOcrOcrIdGroupRoute: LayoutSettingsOcrOcrIdGroupRoute,LayoutSettingsModelsModelIdIndexRoute: LayoutSettingsModelsModelIdIndexRoute,LayoutSettingsOcrOcrIdIndexRoute: LayoutSettingsOcrOcrIdIndexRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)




const LoginGuestRouteChildren = {
  LoginGuestTempRoute: LoginGuestTempRoute,LoginGuestIndexRoute: LoginGuestIndexRoute
}

const LoginGuestRouteWithChildren = LoginGuestRoute._addFileChildren(LoginGuestRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LayoutRoute: LayoutRouteWithChildren,AdMappingRoute: AdMappingRoute,AuditRoute: AuditRoute,HandoffRoute: HandoffRoute,LoginGuestRoute: LoginGuestRouteWithChildren,UsersSplatRoute: UsersSplatRoute,UsersIndexRoute: UsersIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)